var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterPaypalPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 47,
    rx: 5.5,
    style: {
      stroke: "rgb(45, 41, 38)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.088 36.8965L30.5425 33.9983L29.5302 33.9746H24.6962L28.0556 12.5874C28.0661 12.5226 28.0999 12.4625 28.1493 12.4197C28.199 12.3769 28.2623 12.3535 28.3285 12.3535H36.4793C39.1855 12.3535 41.0529 12.9188 42.0277 14.0346C42.4848 14.5581 42.7759 15.1053 42.9168 15.7072C43.0646 16.339 43.067 17.0937 42.9229 18.0143L42.9125 18.0812V18.6712L43.3696 18.9312C43.7544 19.1363 44.0603 19.3709 44.295 19.6395C44.6859 20.0872 44.9388 20.6561 45.0456 21.3304C45.1561 22.024 45.1196 22.8495 44.9388 23.7841C44.7302 24.8589 44.3931 25.7951 43.9377 26.5611C43.519 27.2669 42.9855 27.8524 42.3519 28.306C41.747 28.7371 41.0285 29.0643 40.216 29.2738C39.4286 29.4796 38.531 29.5834 37.5464 29.5834H36.9121C36.4586 29.5834 36.0181 29.7474 35.6722 30.0414C35.3253 30.3415 35.0961 30.7516 35.0257 31.2001L34.9778 31.4611L34.1748 36.5695L34.1385 36.757C34.1288 36.8164 34.1122 36.8459 34.0879 36.866C34.0662 36.8843 34.0351 36.8965 34.0046 36.8965H30.088Z",
    fill: "#28356A"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8029 18.1494C43.7788 18.3055 43.7508 18.4651 43.7196 18.6291C42.6448 24.1704 38.9672 26.0847 34.2705 26.0847H31.879C31.3046 26.0847 30.8205 26.5033 30.7312 27.0722L29.16 37.0788C29.1018 37.4524 29.3885 37.789 29.7639 37.789H34.0054C34.5076 37.789 34.9342 37.4226 35.0133 36.9253L35.055 36.709L35.8536 31.6206L35.9049 31.3415C35.9831 30.8424 36.4107 30.4759 36.9129 30.4759H37.5472C41.6566 30.4759 44.8736 28.8008 45.8139 23.9531C46.2065 21.9281 46.0032 20.2372 44.9639 19.048C44.6494 18.6895 44.2593 18.3918 43.8029 18.1494Z",
    style: {
      fill: "rgb(91, 91, 91)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6779 17.6993C42.5136 17.6511 42.3442 17.6076 42.1704 17.5683C41.9957 17.5299 41.8168 17.4959 41.6325 17.4661C40.9877 17.3615 40.2811 17.3119 39.5244 17.3119H33.1358C32.9783 17.3119 32.8288 17.3476 32.6952 17.4121C32.4005 17.5543 32.1816 17.8344 32.1286 18.1773L30.7694 26.8204L30.7305 27.0723C30.8198 26.5034 31.3039 26.0847 31.8784 26.0847H34.2698C38.9665 26.0847 42.6441 24.1695 43.7189 18.6292C43.7511 18.4652 43.7781 18.3056 43.8022 18.1494C43.5303 18.0045 43.2358 17.8806 42.9186 17.775C42.8403 17.7489 42.7595 17.7237 42.6779 17.6993Z",
    style: {
      fill: "rgb(45, 41, 38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1289 18.1773C32.182 17.8344 32.4008 17.5544 32.6956 17.4131C32.8302 17.3483 32.9786 17.3127 33.1361 17.3127H39.5247C40.2815 17.3127 40.9881 17.3625 41.6328 17.4671C41.8171 17.4967 41.996 17.5309 42.1707 17.5693C42.3445 17.6084 42.5139 17.6521 42.6782 17.7C42.7598 17.7245 42.8406 17.7499 42.9197 17.775C43.2369 17.8806 43.5316 18.0055 43.8035 18.1494C44.1233 16.1017 43.8008 14.7075 42.6982 13.445C41.4824 12.0549 39.2884 11.46 36.4807 11.46H28.3296C27.7562 11.46 27.2669 11.8787 27.1783 12.4486L23.7833 34.0558C23.7164 34.4832 24.0448 34.8689 24.4741 34.8689H29.5062L32.1289 18.1773Z",
    style: {
      fill: "rgb(63, 63, 63)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterPaypalPay);
export default __webpack_public_path__ + "static/media/footer-paypal-pay.0af4c779c3c671721e7cc0cca3050b48.svg";
export { ForwardRef as ReactComponent };